import { BaseRecord, useOne, useResourceParams } from '@refinedev/core';

const useCurrentResource = <TData extends BaseRecord>() => {
  const { id, resource, ...restResource } = useResourceParams();
  const { result, ...rest } = useOne<TData>({ id: id as string, resource: resource?.name });

  return { ...restResource, id, resourceName: resource?.name, data: result || null, ...rest };
};

export default useCurrentResource;
